// 管理深度思考模式的状态

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface DeepThinkStore {
  deepThink: number;
  setDeepThink: (deepThink: number) => void;
}

export const useDeepThinkStore = create<DeepThinkStore>()(
  persist(
    (set) => ({
      deepThink: 0,
      setDeepThink: (deepThink) => set({ deepThink }),
    }),
    {
      name: 'deepthink-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
